import { render } from "./ProfileView.vue?vue&type=template&id=341b83ca"
const script = {}
script.render = render

export default script